import { useProject } from 'queries/queries'
import React from 'react'
import { generateTheme } from 'styles/theme'
import { getProjectId } from 'utilities/get-project-id'
import ThemeProviderContainer from './theme-provider-container'

const ThemeProviderLazy = (props: React.PropsWithChildren) => {
  const { children } = props
  const projectId = getProjectId()
  const { data: project } = useProject({ projectId })

  if (!project) throw Error('No project found, cant load theme')

  const themeInstance = React.useMemo(
    () =>
      generateTheme({
        background: project.backgroundColor,
        primary: project.primaryColor,
        text: project.secondaryColor,
      }),
    [project.backgroundColor, project.primaryColor, project.secondaryColor]
  )

  return <ThemeProviderContainer theme={themeInstance}>{children}</ThemeProviderContainer>
}

export default ThemeProviderLazy
